module.exports = __webpack_public_path__ + "static/media/k50.2e34a803.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/en/k50.png
// module id = 147
// module chunks = 0